import { useContext } from "react";
import { FeedbackDialogContext } from "../context/FeedbackDialogContext";

function useFeedbackDialog() {
    return useContext(FeedbackDialogContext);
}

export default useFeedbackDialog;